export default __webpack_public_path__ + "static/media/b3.7582f5ac.svg";